import React from 'react';
import { Helmet } from 'react-helmet';
import imageUrl from '../../images/opengraph_wide.png';
import config from '../../../gatsby-config';
const configSiteUrl = config.siteMetadata?.siteUrl as string | undefined;

interface IImageProps {
    src: string;
    width: number;
    height: number;
    alt?: string;
}

export interface IOpenGraphProps {
    title?: string;
    locale: string;
    siteName: string;
    type?: 'website' | 'article';
    description?: string;
    url?: string;
    image?: IImageProps;
}

const defaultImageProps: IImageProps = {
    src: imageUrl,
    width: 1200,
    height: 629,
    alt: 'axesCheck powered by axes4',
};

export const OpenGraph: React.FunctionComponent<IOpenGraphProps> = props => {
    const type = props.type ?? 'website';
    const imageProps = props.image ?? defaultImageProps;

    if (!imageProps.src.startsWith('http')) {
        imageProps.src = `${configSiteUrl}/${imageProps.src.replace(/^\//, '')}`;
    }

    return (
        <Helmet>
            {props.title && <meta id="ogTitle" property="og:title" content={props.title}/>}
            <meta id="ogType" property="og:type" content={type}/>
            <meta id="ogSitename" property="og:site_name" content={props.siteName}/>
            <meta id="ogLocale" property="og:locale" content={props.locale}/>
            {props.description && <meta id="ogDescription" property="og:description" content={props.description}/>}
            {props.url && <meta id="ogUrl" property="og:url" content={props.url}/>}
            {imageProps && <meta property="og:image" content={imageProps.src}/>}
            {imageProps && <meta property="og:image:width" content={imageProps.width.toString()}/>}
            {imageProps && <meta property="og:image:height" content={imageProps.height.toString()}/>}
            {imageProps && imageProps.alt && <meta property="og:image:alt" content={imageProps.alt}/>}
        </Helmet>
    );
};
